<template>
    <div style="display: flex" :style="parseInt(item.status) === 1 ? '' : 'opacity: .5'">
        <v-switch
                style="flex-grow: 0;"
                v-model="item.status"
                  hide-details
                  color="blue"
                  :false-value="String(0)"
                  :true-value="String(1)"
                  @change="changeActive"
        />

        <span @click="$bus.$emit('pricelist:edit-item', [item, idx, 'title'])" style="font-size: 13px; border-bottom: 2px solid #999; display: inline-block; flex-grow: 1; padding-top: 24px;"> {{ item.title[$store.state.language] }}</span>

        <span @click="$bus.$emit('pricelist:edit-item', [item, idx, 'price'])" style="text-align: right; width: 90px; max-width: 90px; margin-left: 12px; font-size: 14px; border-bottom: 2px solid #999; display: inline-block; flex-grow: 0; padding-top: 24px;"> {{ formattedUnitPrice }}</span>

            <!-- <v-text-field
                v-model="item.title[$store.state.language]"
                maxlength="42"
                class="text-field--f13"
                :style="parseInt(item.status) === 1 ? '' : 'opacity: .5'"
                hide-details
                :placeholder="$t('settings.type_treatment')"
                @focus="onFocus"
                @blur="onBlur"
                @keypress="onEnterPress"
        /> -->

        <!-- <pm-price-input @click="onPriceClick" v-model="item.price[$store.state.currency]" :style="parseInt(item.status) === 1 ? '' : 'opacity: .5'" /> -->
    </div>
</template>

<style>
    .settings-input--unit-price input {
        text-align: right;

    }
    .v-text-field.text-field--f13 input {
        font-size: 13px!important;
        letter-spacing: -0.5px;
    }
</style>

<script>

import { scrollElementToTop } from "../../utils/user-interface";

export default {
    props: {
        item: {
            type: Object,
            default: function() {
                return ({
                    status: "1",
                    title: {},
                    price: {},
                });
            },
        },
        idx: {
            type: Number,
            default: 0,
        }
    },
    data: () => {
        return ({
            switch1: true,
            unitPrice: "100",
            price: 0,
        });
    },
    computed: {
        settings() {
            return '.';
        },
        formattedUnitPrice: {
            get() {
                let price = this.item.price[this.$store.state.currency];

                if (typeof price === "undefined" || price === 0) {
                    return 0;
                }

                price = this.addThousandSeparator(price.toString().replace(",", "."));

                return price;
            },
            set(val) {
                const price = val.toString().replace(/([^0-9]+)/g, "");
                this.$set(this.item.price, this.$store.state.currency, price);
                this.$set(this, "price", price);
            },
        },
    },
    methods: {
        onPriceClick() {
            if (parseInt(this.item.status) === 0) {
                this.item.status = '1';
                this.changeActive();
            }
        },
        handleDecimals(n) {
            return Number.isInteger(n) ? parseInt(n) : n.toFixed(this.settings.decimals);
        },
        addThousandSeparator(n) {
            const nStr = n.toString();
            const remainder = nStr.length % 3;

            let formatted = (nStr.substr(0, remainder) + nStr.substr(remainder).replace(/(\d{3})/g, ' ' + "$1")).trim();

            if (formatted[0] === ' ') {
                formatted = formatted.substr(1);
            }

            return formatted;
        },
        selectText(event) {
            const $input = event.target;

            $input.focus();
            $input.selectionStart = $input.selectionEnd = $input.value.length;
        },
        formatPrice(price) {
            let n = this.value;

            n = Number(parseFloat(n).toFixed(4) + 0);

            return this.addThousandSeparator(this.handleDecimals(n));
        },
        changeActive() {
            this.$emit("toggle");
        },
        // onBlur() {
        //     this.$emit("blurred");

        //     document.querySelector("#main-scrollable-content .scroll-helper").style.height = 0;
        // },
        onFocusPrice(event) {
            event.target.select();  // uncomment if approved
            this.onFocus(event);
        },
        onFocus(event) {
            this.$emit("focused");

            window.softKeyboardShown = true;

            if (parseInt(this.item.status) === 0) {
                this.item.status = '1';
                this.changeActive();
            }

            scrollElementToTop(event.target, 0);
            /*const {abs} = Math;
            const {clientHeight} = document.documentElement;
            const {top} = event.target.getBoundingClientRect();
            const shouldScrollUp = abs(1 - (clientHeight - top) / clientHeight);

            if (shouldScrollUp <= 0.6) {
                return;
            }

            const $content = document.querySelector("#main-scrollable-content");
            const $scrollHelper = $content.querySelector(".scroll-helper");

            if ($content.scrollTop / $content.scrollHeight > 0.7) {
                $scrollHelper.style.height = "40vh";
            }

            $content.scrollTo({top: $content.scrollTop + parseInt(clientHeight / 3), behavior: "smooth"});*/
        },
        onBlur() {
            this.$emit('blurred');
            window.setTimeout(() => {
                window.softKeyboardShown = false;
            }, 500);
        },
        onEnterPress(event) {
            if (event.code === "Enter" || event.key === "Enter" || event.keyCode === 13) {
                return event.target.blur();
            }
        },
        onKeypress(event) {
            const charCode = event.which || event.keyCode;

            if (event.code === "Enter" || event.key === "Enter" || event.keyCode === 13) {
                return event.target.blur();
            }

            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                event.preventDefault();
            }
        },
    },
};
</script>
